import { memo, ReactNode } from 'react';

import { markSlot } from './slot-marker';

export type PlayerListTemplateV2ActionButtonProps = {
  /** Content used on both phone and tablet unless `mobile`/`tablet` are set. */
  children?: ReactNode;
  /** Phone-specific content (overrides `children` on phone). */
  mobile?: ReactNode;
  /** Tablet-specific content (overrides `children` on tablet). */
  tablet?: ReactNode;
};

/**
 * Screen-level primary action (e.g. "Create Profile", "Add Tracking",
 * "New Player"). This slot is a pure data container — it doesn't render any
 * layout itself. `Toolbar` extracts it and wraps it with the correct layout:
 *
 * - phone: absolutely positioned above the (animated) filter group,
 *   synced to scroll offset.
 * - tablet: inline inside the toolbar row.
 */
function ActionButtonComponent(_props: PlayerListTemplateV2ActionButtonProps) {
  return null;
}

const MemoActionButton = memo(ActionButtonComponent);
MemoActionButton.displayName = 'PlayerListTemplateV2.ActionButton';

export const ActionButton = markSlot(MemoActionButton, 'action');
